export default __webpack_public_path__ + "static/media/client-18.dd6aa984.webp";